export const CALL_SET_RECEIVED_MOVE = 'CALL_SET_RECEIVED_MOVE'
export const CALL_SET_GAME_STATE_CHANGE = 'CALL_SET_GAME_STATE_CHANGE'
